export default __webpack_public_path__ + "static/media/icon_record_video_disabled.b02b1d5e.svg";